import { apiClient } from '@/libs/axios';
import type { MutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { z } from 'zod';

export const CreateAdminSchema = z
  .object({
    name: z.string().min(1, 'Nama admin wajib diisi'),
    email: z.string().email('Email tidak valid'),
    password: z.string().min(6, 'Password minimal 6 karakter'),
    password_confirmed: z
      .string()
      .min(6, 'Konfirmasi password minimal 6 karakter'),
    role_id: z.string().min(1, 'Role wajib dipilih'),
  })
  .refine(data => data.password === data.password_confirmed, {
    message: 'Konfirmasi password tidak sama',
    path: ['password_confirmed'],
  });

export type CreateAdminData = z.infer<typeof CreateAdminSchema>;

export const createAdmin = async (data: CreateAdminData): Promise<void> => {
  return await apiClient.post('/admin', data);
};

export function createAdminMutationOptions(): MutationOptions<
  void,
  AxiosError,
  CreateAdminData
> {
  return {
    mutationFn: createAdmin,
  };
}
